import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Avatar,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { UPDATE_USER_ROLE } from "../../Schema/User";
import { translateLauguage } from "../../Function/Translate";

export default function UpdateUser({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [updateAccountingUserRole] = useMutation(UPDATE_USER_ROLE, {
    onCompleted: ({ updateAccountingUserRole }) => {
      setLoading(false);
      // console.log("updateAccountingUserRole::", updateAccountingUserRole);
      if (updateAccountingUserRole?.status === true) {
        setAlert(true, "success", updateAccountingUserRole?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateAccountingUserRole?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });
  // console.log("editData", editData);

  //fromik
  const UpdateUser = Yup.object().shape({
    role: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      role: editData?.role,
    },

    validationSchema: UpdateUser,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      updateAccountingUserRole({
        variables: {
          id: editData?._id,
          role: values?.role,
        },
      });
    },
  });

  const { handleSubmit, setFieldValue, values, resetForm } = formik;

  useEffect(() => {
    if (editData?._id) {
      setFieldValue("role", editData?.role);
    }
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_update_role")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    className="avater-image"
                    src={editData?.userProfile ? editData?.userProfile : ""}
                  />
                </Stack>
                <Typography
                  className="field-title"
                  sx={{ textAlign: "center" }}
                >
                  Profile image
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography
                  className="field-title"
                  style={{ fontSize: "16px" }}
                >
                  Do you want to update{" "}
                  {editData?.lastName + " " + editData?.firstName}'s role?
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_role")}
                </Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.role}
                    onChange={(e) => setFieldValue("role", e.target.value)}
                  >
                    <MenuItem value="Admin">Admin</MenuItem>
                    <MenuItem value="AffairDirector">Affair director</MenuItem>
                    <MenuItem value="HeadOffice">Headffice</MenuItem>
                    <MenuItem value="AccountReceived">
                      Account received
                    </MenuItem>
                    <MenuItem value="AccountPayable">Account payable</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
